import { useEffect, useContext } from 'react';
import logStartedRoutine from './LogStartedRoutineMutation.gql';
import {
  logStartedRoutine as logStartedRoutineData,
  logStartedRoutineVariables,
} from './_QueryTypes/logStartedRoutine';
import { ActiveDatabaseContext } from '../../../../../Components/ActiveDatabaseContext/ActiveDatabaseContext';
import {
  StartedRoutinesQuery as StartedRoutinesQueryData,
  StartedRoutinesQueryVariables,
} from '../../../../StartPanel/Components/Cards/StartedRoutines/Queries/_QueryTypes/StartedRoutinesQuery';
import startedRoutinesQuery from '../../../../StartPanel/Components/Cards/StartedRoutines/Queries/StartedRoutinesQuery.gql';
import { LoginStateContext } from '../../../../Login/Contexts/LoginStateContext/LoginStateContext';
import { useApolloClient } from '@apollo/client/react';

export const useLogStartedRoutine = (rutinId: number) => {
  const loginState = useContext(LoginStateContext);
  const { activeDatabase } = useContext(ActiveDatabaseContext);
  const apolloClient = useApolloClient();

  useEffect(() => {
    if (apolloClient && loginState.isLoggedIn && activeDatabase) {
      apolloClient.mutate<logStartedRoutineData, logStartedRoutineVariables>({
        mutation: logStartedRoutine,
        variables: {
          routine: rutinId,
          dbname: activeDatabase,
        },
        update: (proxy, result) => {
          if (result.data && result.data.startedroutine) {
            proxy.writeQuery<
              StartedRoutinesQueryData,
              StartedRoutinesQueryVariables
            >({
              query: startedRoutinesQuery,
              variables: { dbname: [activeDatabase] },
              data: {
                me: [
                  {
                    __typename: 'TEDAvenyUserInfo',
                    startedroutines: result.data.startedroutine,
                  },
                ],
              },
            });
          }
        },
      });
    }
  }, [loginState.isLoggedIn, activeDatabase, apolloClient, rutinId]);
};
